import React from 'react'

const NiIncome = () => {
  return (
    <svg width="24" height="24" class="mb-4 text-text-primary" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="14.5" r="7.5" stroke="currentColor" strokeWidth="1.5"></circle><path opacity="0.6" d="M16.65 16.6873C19.7443 15.7629 21.9999 12.8949 21.9999 9.5C21.9999 5.35786 18.6421 2 14.4999 2C11.0504 2 8.14478 4.32881 7.26953 7.5" stroke="currentColor" strokeWidth="1.5"></path><path d="M7.5 12.5L9.5 13L11.5 12.5L11 14.5L11.5 16.5L9.5 16L7.5 16.5L8 14.5L7.5 12.5Z" stroke="currentColor" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
  )
}

export default NiIncome
